export default __webpack_public_path__ + "static/media/ic_add.f0a4ca8f.svg";